import React from 'react';
import LiveIvrConfirmation from './LiveIvrConfirmation';

export default function IvrSubmissionFooter({
  liveIvr,
  admin,
  liveConfirmed,
  setLiveConfirmed,
  busy,
  viewOnly,
  close,
  handleSubmit,
  canSubmit,
  submitting,
  t,
}) {
  return (
    <>
      <LiveIvrConfirmation
        liveIvr={liveIvr}
        admin={admin}
        confirmed={liveConfirmed}
        setConfirmed={setLiveConfirmed}
        disabled={busy || viewOnly}
        t={t}
      />
      <div className="flex items-center justify-end gap-3">
        <button
          onClick={close}
          className="text-[13px] font-medium text-[#64748b] hover:text-[#0f172a] transition-colors"
        >
          {t('Cancel')}
        </button>
        <button
          onClick={handleSubmit}
          disabled={!canSubmit}
          className={`h-[36px] px-5 rounded-[6px] text-[13px] font-medium transition-colors ${
            canSubmit
              ? 'bg-[#0089ff] text-white hover:bg-[#0077e6]'
              : 'bg-[#e2e8f0] text-[#97a3b6] cursor-not-allowed'
          }`}
        >
          {submitting ? t('Submitting...') : t('Submit IVR')}
        </button>
      </div>
    </>
  );
}
